export default "__VITE_ASSET__C5qFq1IN__"